import { ModuleCode } from '@reporting/rp-types/accounting';

export const BALANCE_TYPES = [
    {k: 1, v: 1},
    {k: 2, v: 2},
    {k: 3, v: 3},
    {k: 4, v: 4},
];

export const DATE_FORMATS = [
    { k: 'dd.MM.yyyy', v: 'dd.MM.yyyy' },
    { k: 'MM/dd/yyyy', v: 'MM/dd/yyyy' },
    { k: 'yyyy-MM-dd', v: 'yyyy-MM-dd' }
];

export const MONTH_FORMATS = [
    { k: 'MMMM yyyy', v: 'MMMM yyyy' },
    { k: 'MMM yyyy', v: 'MMM yyyy' },
    { k: 'MM/yyyy', v: 'MM/yyyy' }
];

export type EmbedModule = ModuleCode | 'R' | 'MDM';

export const EMBEDDING_URL = 'https://report.reporting.cz/{a}/{m}/embed/{id}';

/**
 * An OpenID Connect preset - the client of our own multi-tenant application a group may sign in with
 * instead of registering one (rp-ms-accounting GET /ssoOidcPresets). Superadmins also get `settings`
 * and `has_secret`; the secret itself never leaves the server.
 */
export type SsoOidcPreset = {
	id: number;
	name: string;
	client_id: string;
	base_url: string;
	settings?: string | null;
	has_secret?: boolean;
	client_secret?: string;
};
